.root {
  box-shadow: var(--mantine-shadow-xs);
}

.icon {
  &[data-rotate] {
    animation: spin 2s linear infinite;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
